import React, { useState } from 'react'
import { CardTable } from 'components/datatable/NewTable'
import PropTypes from 'prop-types'
import { push } from '@lagunovsky/redux-react-router'
import { useDispatch } from 'react-redux'
import { exportFile } from '../../../../utils/ExportDataUtil'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import DatePicker from '../../../../components/forms/DatePicker'
import Select from '../../../../components/forms/Select'
import Textarea from '../../../../components/forms/Textarea'
import moment from 'moment'
import { darkBlue } from '../../../../utils/constants/ColorTheme'

const SimSubscriptionTable = ({
    editMode = false,
    links = [],
    onDelete = () => {},
    onAdd = () => {},
    title = '',
    headers = [],
    associatedMateriels = [],
    idKeyToRedirect = '',
    redirectTo = 'sim',
}) => {
    const dispatch = useDispatch()

    const [isOpen, setIsOpen] = useState(false)
    const [newLink, setNewLink] = useState(() => ({ startDate: moment().valueOf() }))

    const resetState = () => {
        setIsOpen(false)
        setNewLink({ startDate: moment().valueOf() })
    }

    const exportData = links.map((link, index) => {
        if (index === 0) {
            return {
                ...link,
                headers,
            }
        }
        return link
    })

    const actions = [
        {
            icon: 'note_add',
            color: 'white',
            onClick: () => setIsOpen(true),
            displayed: editMode,
        },
        {
            icon: 'file_download',
            color: 'white',
            onClick: () => exportFile({
                data: exportData,
                exportType: 'xlsx',
                titleFile: title,
            }),
        },
    ]

    const lineActions = [
        {
            icon: 'delete',
            onClick: onDelete,
            displayed: editMode,
        },
    ]

    return (
        <Grid container sx={{ marginTop: '1rem' }}>
            <Grid size={9}>
                <CardTable
                    title={title}
                    rows={links}
                    color={darkBlue}
                    headers={headers}
                    actions={actions}
                    lineActions={lineActions}
                    onClickRow={({ [idKeyToRedirect]: id }) => dispatch(push(`/materiel/${redirectTo}/${id}`))}
                />
            </Grid>
            <Dialog
                onClose={resetState}
                fullWidth
                maxWidth='lg'
                open={isOpen}
            >
                <DialogTitle>{i18n.newLink}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} sx={{ minHeight: '30vh' }}>
                        <Grid size={9}>
                            <Select
                                options={associatedMateriels}
                                label={i18n.materiels}
                                onChange={v => setNewLink(prev => ({ ...prev, materielLink: v }))}
                                value={newLink.materielLink}
                                nullLabel='&nbsp;'
                                clearFunction
                            />
                        </Grid>
                        <Grid size={3}>
                            <DatePicker
                                title={i18n.startDate}
                                value={newLink.startDate}
                                onChange={(_, v) => setNewLink(prev => ({ ...prev, startDate: v }))}
                            />
                        </Grid>
                        <Grid size={12}>
                            <Textarea
                                title={i18n.comment}
                                value={newLink.comment}
                                onChange={v => setNewLink(prev => ({ ...prev, comment: v }))}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={resetState} variant='outlined' >
                        {i18n.close}
                    </Button>
                    <Button
                        onClick={() => {
                            resetState()
                            onAdd(newLink)
                        }}
                        variant='contained'
                        color='primary'
                    >
                        {i18n.validate}
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}

SimSubscriptionTable.propTypes = {
    editMode: PropTypes.bool,
    links: PropTypes.arrayOf(PropTypes.shape({
        sim: PropTypes.string,
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        comment: PropTypes.string,
    })),
    headers: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string,
    idKeyToRedirect: PropTypes.string,
    redirectTo: PropTypes.oneOf(['sim', 'subscription', 'telecom']),
    associatedMateriels: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.number,
        name: PropTypes.string,
    })),
    onDelete: PropTypes.func,
    onAdd: PropTypes.func,
}

export default SimSubscriptionTable